// extracted by mini-css-extract-plugin
export default {"zoomModal":"o5-z"};